export default __webpack_public_path__ + "static/media/20210501_000001-min.d7917be4.jpg";